import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CForm,
  CFormInput,
  CFormLabel
} from "@coreui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { createVehicleSchema, department, fuelType, initialValues, licenseType } from "./static";
import { getActiveCountryList } from "src/services/country.services";
import { createVehicle, getSingleVehicle, updateVehicle } from "src/services/vehicle";
import toast from "react-hot-toast";



const CreateVehicle = () => {
  const [countryData, setCountryData] = useState([]);
  const [selecTedFuelType, setSelectedFuelType] = useState(null);
  const [drivingLicenseType, setdrivingLicenseType] = useState([]);
  const [userImage, setUserImage] = useState(null);
  const [SelectedDeparment, setSelectedDeparment] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedLicense, setSelectedLicense] = useState(null);
  const [submitLoader,setSubmitLoader] = useState(false);
  const [vehicleData,setVehicleData]=useState({});
  const {id} = useParams();

  //store userType value = 64a64b36a2ef02fb5725b215
  

  const {
    control,
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    setError,
    watch,
    formState: { errors },
  } = useForm({
      defaultValues: initialValues,
    resolver: zodResolver(createVehicleSchema),
  });

  const findItemFromOpt=(arr,value,key)=>{
    return arr.find((item) => item[key??"value"] === value);
  }

  const getVehicleData=async()=>{
    try{
      const response = await getSingleVehicle(id);
      console.log(response,"response");
      if(response?.data){
        setVehicleData(response?.data);
        setValue("vehicleId", response?.data?.vehicleId);
        setValue("deviceId", response?.data?.deviceId);
        setValue("maxSpeed", response?.data?.maxSpeed);
        setValue("drivingLicenseType", response?.data?.drivingLicenseType);
        setValue("purchaseAmount", response?.data?.purchaseAmount);
        setValue("region", response?.data?.region);
        setValue("registrationNo", response?.data?.registrationNo);
        setValue("simCardNumber", response?.data?.simCardNumber);
        setValue("mileage", response?.data?.mileage);
        setValue("fuelType", response?.data?.fuelType);
        setValue("vehicleType", response?.data?.vehicleType);
        setValue("department", response?.data?.department);
        const depFromDb = findItemFromOpt(department,response?.data?.department);
        const drivingLicenseType = findItemFromOpt(licenseType,response?.data?.drivingLicenseType);
        const region = findItemFromOpt(countryData,response?.data?.region,"_id");
        console.log(countryData,"countryData");
        const fuelTypeFromDb = findItemFromOpt(fuelType,response?.data?.fuelType);
        setSelectedDeparment(depFromDb);
        setSelectedRegion(region);
        setSelectedFuelType(fuelTypeFromDb);
        setSelectedLicense(drivingLicenseType);
      }
    }catch(e){
      console.log(e);
    }
  }

  useEffect(() => {
    getVehicleData();
  },[])

  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );

  const onSubmit = async(data) => {
    setSubmitLoader(true)
    toast.loading(`${id?"Updating":"Creating"} Vehicle...`, { id: "create-vehicle" });
    try{
      let createData,updateData;
      if(id){
        if(data.vehicleId===vehicleData?.vehicleId){
          delete data.vehicleId
        }
        updateData = await updateVehicle(data,id);
      }else{
        createData = await createVehicle(data);
      }
      if(createData?.data?.insertedId){
        toast.success("Vehicle created successfully");
        reset()
      }else if(updateData?.success){
        toast.success("Vehicle updated successfully");
      }else{
        toast.error(createData.data?.message);
      }
    }catch(e){
      console.log(e);
      toast.error(e?.response?.data?.message ?? "Something went wrong");
    }finally{
      toast.dismiss("create-vehicle");
      setSubmitLoader(false)
    }
  };

  const onError = (err) => {
    console.error(err,watch());
  };

  const handleSelectChange = (e,setMethod,property,region) => {
    setMethod(e);
    setValue(property, e?.[region??'value']?? null);
    console.log(e);
    
    if(e?.[region??'value']){
      setError(property, null);
    }
  };

  const getCountryList=async()=>{
    const response = await getActiveCountryList({limit:20,page:1});
    const countries  = response?.data;
    
    setCountryData(countries);
  }

  useEffect(() => {
    if(vehicleData?.region && countryData.length>0){
        const region = findItemFromOpt(countryData,vehicleData?.region,"_id");
        setSelectedRegion(region);
    }
  },[vehicleData,countryData])

  useEffect(() => {
    getCountryList();
  }, []);
  
  return (
    <CCard className="mb-4">
      <CCardBody>
        <CRow>
          <CCol sm={5}>
            <h4 id="traffic" className="card-title mb-0">
               {id?"Edit":"Create"} Vehicle
            </h4>
          </CCol>
          <CCol sm={7} className="d-none d-md-block"></CCol>
        </CRow>
        <hr />
        <br />
        <CForm onSubmit={handleSubmit(onSubmit, onError)}>
          <CRow>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="userType"
                  className="col-sm-3 col-form-label"
                >
                  Vehicle Id:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="vehicleId"
                    placeholder="Vehicle Id"
                    {...register("vehicleId")}
                  />
                  {errors.vehicleId?.message && (
                    <p className="error_text">{errors.vehicleId?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="deviceId"
                  className="col-sm-3 col-form-label"
                >
                  Device Id:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    placeholder="Device Id"
                    type="text"
                    id="deviceId"
                    {...register("deviceId")}
                  />
                  {errors.deviceId?.message && (
                    <p className="error_text">{errors.deviceId?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="maxSpeed"
                  className="col-sm-3 col-form-label"
                >
                  Maximum Speed:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    maxLength={6}
                    placeholder="Maximum Speed"
                    id="maxSpeed"
                    {...register("maxSpeed")}
                  />
                  {errors.maxSpeed?.message && (
                    <p className="error_text">{errors.maxSpeed?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="drivingLicenseType"
                  className="col-sm-3 col-form-label"
                >
                  Driving License Type:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    value={selectedLicense}
                    onChange={(e) => handleSelectChange(e, setSelectedLicense,"drivingLicenseType")}
                    options={licenseType}
                    isClearable={true}
                    placeholder="Select Driving License Type"
                    isDisabled={
                      !drivingLicenseType && drivingLicenseType?.length <= 0 ? true : false
                    }
                  />

                  {errors.drivingLicenseType?.message && (
                    <p className="error_text">{errors.drivingLicenseType?.message}</p>
                  )}
                </CCol>
              </CRow>
              
             
              {/* :''} */}
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="purchaseAmount"
                  className="col-sm-3 col-form-label"
                >
                  Purchase Amount:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    placeholder="Purchase Amount"
                    type="text"
                    id="purchaseAmount"
                    {...register("purchaseAmount")}
                  />
                  {errors.purchaseAmount?.message && (
                    <p className="error_text">
                      {errors.purchaseAmount?.message}
                    </p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="region"
                  className="col-sm-3 col-form-label"
                >
                  Region:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    value={selectedRegion}
                    onChange={(e) => handleSelectChange(e, setSelectedRegion,"region","_id")}
                    options={countryData}
                    isClearable={true}
                    placeholder="Select Region"
                    getOptionLabel={(option) => option?.name}
                    getOptionValue={(option) => option?._id}
                    isDisabled={
                      !drivingLicenseType && drivingLicenseType?.length <= 0 ? true : false
                    }
                  />

                  {errors.region?.message && (
                    <p className="error_text">{errors.region?.message}</p>
                  )}
                </CCol>
              </CRow>
            </CCol>
            <CCol sm={6}>
              
              <CRow
                className={`mb-3`}
              >
                <CFormLabel
                  htmlFor="registrationNo"
                  className="col-sm-3 col-form-label"
                >
                  Registration NO:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="registrationNo"
                    id="registrationNo"
                    placeholder="Registration No"
                    {...register("registrationNo")}
                  />
                  {errors.registrationNo?.message && (
                    <p className="error_text">
                      {errors.registrationNo?.message}
                    </p>
                  )}
                </CCol>
              </CRow>
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="simCardNumber"
                    className="col-sm-3 col-form-label"
                  >
                    Sim Card Number:
                  </CFormLabel>
                  <CCol sm={8}>
                    <CFormInput
                      placeholder="Sim Card Number"
                      type="text"
                      id="simCardNumber"
                      // required={selecteduserType !== "store" ? true : false}
                      {...register("simCardNumber")}
                    />
                    {errors.simCardNumber?.message && (
                      <p className="error_text">{errors.simCardNumber?.message}</p>
                    )}
                  </CCol>
                </CRow>
              

             

              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="mileage"
                  className="col-sm-3 col-form-label"
                >
                  Mileage:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput placeholder="Mileage" type="mileage" id="mileage" {...register("mileage")} />
                  {errors.mileage?.message && (
                    <p className="error_text">{errors.mileage?.message}</p>
                  )}
                </CCol>
              </CRow>

              <CRow
                className={`mb-3 `}
              >
                <CFormLabel
                  htmlFor="fuelType"
                  className="col-sm-3 col-form-label"
                >
                  Fuel Type:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    value={selecTedFuelType}
                    onChange={(e) => handleSelectChange(e, setSelectedFuelType,"fuelType")}
                    options={fuelType}
                    isClearable={true}
                    placeholder="Select Fuel Type"
                    // isDisabled={
                    //   !drivingLicenseType && drivingLicenseType?.length <= 0 ? true : false
                    // }
                  />

                  {errors.fuelType?.message && (
                    <p className="error_text">{errors.fuelType?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="vehicleType"
                  className="col-sm-3 col-form-label"
                >
                  Vehicle Type:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput placeholder="Vehicle Type" type="vehicleType" id="vehicleType" {...register("vehicleType")} />
                  {errors.vehicleType?.message && (
                    <p className="error_text">{errors.vehicleType?.message}</p>
                  )}
                </CCol>
                
              </CRow>
               <CRow className="mb-3">
                <CFormLabel
                  htmlFor="department"
                  className="col-sm-3 col-form-label"
                >
                  Department:
                </CFormLabel>

                <CCol sm={8}>
                  <Select
                    value={SelectedDeparment}
                    onChange={(e) => handleSelectChange(e, setSelectedDeparment,"department")}
                    options={department}
                    isClearable={true}
                    placeholder="Select Department"
                    // isDisabled={
                    //   !drivingLicenseType && drivingLicenseType?.length <= 0 ? true : false
                    // }
                  />

                  {errors.department?.message && (
                    <p className="error_text">{errors.department?.message}</p>
                  )}
                </CCol>
              </CRow>

              {userImage ? (
                <CRow className="mb-3">
                  <CCol sm={12}>
                    <img src={userImage} height={110} />
                  </CCol>
                </CRow>
              ) : (
                ""
              )}
            </CCol>
            <div className="d-flex justify-content-end mt-3">
              <CButton disabled={submitLoader} type="submit" color="primary" className="px-5 py-2 me-3">
                Submit
              </CButton>
            </div>
          </CRow>
        </CForm>
      </CCardBody>
    </CCard>
  );
};

export default CreateVehicle;
